import platform from '@play-co/gcinstant';
import StateObserver from 'src/StateObserver';

const lineSettingsAppLink = 'https://line.me/R/nv/connectedApps';

export function isFirstEntryOfDay(): boolean {
  const now = StateObserver.now();
  const lastEntryTime = platform.getPreviousEntryTimestamp();
  const lastEntryDate = new Date(lastEntryTime);
  const today = new Date(now);

  return (
    today.getDate() !== lastEntryDate.getDate() ||
    today.getMonth() !== lastEntryDate.getMonth() ||
    today.getFullYear() !== lastEntryDate.getFullYear()
  );
}

export function openLineSettings() {
  if (platform.osType === 'IOS_APP') {
    window.location.assign(lineSettingsAppLink);
  } else {
    window.open(lineSettingsAppLink);
  }
}

/** Remove Splash screen, also the loading bar */
export function removeSplashScreen() {
  const splashScreen = document.querySelector('#splashScreen');
  if (splashScreen) document.body.removeChild(splashScreen);
}
